





















































































































































































































































































































import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import { IRole, IStaff } from "@/@types/admin/staff";
import { ILocale } from "@/@types/locale";

import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
import { staff_description } from "@/config/user/description";

import UploadPicture from "@/components/app/images/upload-picture.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import BSwitch from "../../app/switchs/b-switch.vue";
import DatePicker from "vue2-datepicker";
import buttonLocales from "@/components/buttons/button-locales.vue";
import CyrillicToTranslit from "cyrillic-to-translit-js";
import DocumentsForm from "@/components/app/documents-form.vue";
import ZItStaffData from "./z-it-staff-data.vue";
import Citizenship from "@/components/app/citizenship.vue";
import StaffRoles from "@/components/app/staff-roles.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import "vue2-datepicker/locale/ru";
import "vue2-datepicker/locale/en";

@Component({
  mixins: [validationMixin],
  validations: {
    surname: { required },
    name: { required },
    post: { required },
    zit_surname: {
      required: requiredIf(function (this: any) {
        return this.$store.getters.zit;
      }),
    },
    zit_name: {
      required: requiredIf(function (this: any) {
        return this.$store.getters.zit;
      }),
    },
    docNumber: {
      required: requiredIf(function (this: any) {
        return this.$store.getters.zit;
      }),
    },
    docType: {
      required: requiredIf(function (this: any) {
        return this.$store.getters.zit;
      }),
    },
    gender: {
      required: requiredIf(function (this: any) {
        return this.$store.getters.zit;
      }),
    },
    citizenship: {
      required: requiredIf(function (this: any) {
        return this.$store.getters.zit;
      }),
    },
  },
  components: {
    StandartModal,
    BSwitch,
    VueEditor,
    UploadPicture,
    onsubmit: SubmitResetButtonGroop,
    DatePicker,
    "locale-btn": buttonLocales,
    DocumentsForm,
    ZIT: ZItStaffData,
    Citizenship,
    StaffRoles,
  },
})
export default class Staff extends Vue {
  @Inject("staffPhoto") readonly folder!: string;
  @Prop({ type: Object, default: null }) persone!: IStaff;
  @Prop({ type: Array, default: () => [] }) roles!: Array<IRole>;

  cyrillicToTranslit = new (CyrillicToTranslit as any)();
  locale = this.$store.getters.getLanguages[0];
  staff_description = staff_description;

  name = "";
  surname = "";
  patronymic = "";
  names: ILocale = {};

  post = "";
  description = "";
  descriptions: ILocale = {};
  birthday: Date | null = null;
  hiringDate: Date | null = null;
  dismissalDate: Date | null = null;
  show = true;
  on_board = false;
  tips = "";
  image = "";

  zit_name = "";
  zit_surname = "";
  zit_patronymic = "";

  docType = "0";
  docNumber = "";
  gender = 0;
  citizenship = "";
  diploma = "";

  get staff(): IStaff {
    return {
      _id: this.persone ? this.persone._id : "",
      name: this.names,
      post: this.post,
      description: this.descriptions,
      birthday: this.birthday,
      show: this.show,
      on_board: this.on_board,
      src: {
        image: this.image,
        tips: this.tips,
      },
      data_zit: {
        surname: this.zit_surname,
        name: this.zit_name,
        patronymic: this.zit_patronymic,
        birthday: this.birthday,
        docType: this.docType,
        docNumber: this.docNumber,
        gender: this.gender,
        citizenship: this.citizenship,
        rank: this.rank,
        diploma: this.diploma,
        hiringDate: this.hiringDate,
        dismissalDate: this.dismissalDate,
      },
    };
  }

  get rank(): string {
    const rank = this.roles.find((r) => r._id == this.post);
    if (!rank) return "";
    const name = rank.name.ru;
    return name ? name : "";
  }

  @Watch("locale")
  updateLocale(): void {
    if (this.descriptions)
      this.description = this.descriptions[this.locale]
        ? this.descriptions[this.locale]
        : "";
    else this.description = "";
  }

  @Watch("surname")
  @Watch("name")
  @Watch("patronymic")
  changeName(): void {
    const full_name = this.surname + " " + this.name + " " + this.patronymic;
    this.names.ru = full_name;

    if (this.locale != "en")
      this.names.en = this.cyrillicToTranslit.transform(full_name);

    if (this.locale != "ru")
      this.names.ru = this.cyrillicToTranslit().reverse(full_name);
  }

  @Watch("name")
  changezit_name(): void {
    this.zit_name = this.name;
  }
  @Watch("surname")
  changezit_surname(): void {
    this.zit_surname = this.surname;
  }
  @Watch("patronymic")
  changezit_patronymic(): void {
    this.zit_patronymic = this.patronymic;
  }

  @Watch("description")
  changeDescription(): void {
    this.descriptions[this.locale] = this.description;
  }

  @Watch("persone")
  autoFillingForm(): void {
    this.onReset();
    if (!this.persone) return;

    this.names = this.persone.name;
    this.post = this.persone.post;
    this.descriptions = this.persone.description;
    this.show = this.persone.show;
    this.on_board = this.persone.on_board;
    this.tips = this.persone.src.tips;
    this.image = this.persone.src.image ? this.persone.src.image : "";

    this.birthday = this.persone.birthday
      ? new Date(this.persone.birthday)
      : null;
    this.hiringDate = this.persone.data_zit?.hiringDate
      ? new Date(this.persone.data_zit?.hiringDate)
      : null;
    this.dismissalDate = this.persone.data_zit?.dismissalDate
      ? new Date(this.persone.data_zit?.dismissalDate)
      : null;

    this.updateLocale();

    if (this.names) {
      const full_name = this.names.ru ? this.names.ru : "";

      const arr = full_name.split(" ");
      this.surname = arr[0] ? arr[0] : "";
      this.name = arr[1] ? arr[1] : "";
      this.patronymic = arr[2] ? arr[2] : "";

      this.zit_name = this.persone.data_zit?.name
        ? this.persone.data_zit.name
        : this.name;
      this.zit_surname = this.persone.data_zit?.surname
        ? this.persone.data_zit.surname
        : this.surname;
      this.zit_patronymic = this.persone.data_zit?.patronymic
        ? this.persone.data_zit.patronymic
        : this.patronymic;
      this.docType = this.persone.data_zit?.docType
        ? this.persone.data_zit.docType
        : "";
      this.docNumber = this.persone.data_zit?.docNumber
        ? this.persone.data_zit.docNumber
        : "";
      this.gender = this.persone.data_zit?.gender
        ? this.persone.data_zit?.gender
        : 0;
      this.citizenship = this.persone.data_zit?.citizenship
        ? this.persone.data_zit?.citizenship
        : "";
      this.diploma = this.persone.data_zit?.diploma
        ? this.persone.data_zit?.diploma
        : "";
      this.hiringDate = null;
      this.dismissalDate = null;
    }
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }

    this.$emit("change", this.staff, this.staff._id);
  }

  onReset(): void {
    this.locale = this.$store.getters.getLanguages[0];
    this.name = "";
    this.surname = "";
    this.patronymic = "";
    this.names = {};
    this.post = "";
    this.description = "";
    this.descriptions = {};
    this.birthday = null;
    this.show = false;
    this.on_board = false;
    this.tips = "";
    this.image = "";
    this.zit_name = "";
    this.zit_surname = "";
    this.zit_patronymic = "";
    this.gender = 0;
    this.citizenship = "";
    this.diploma = "";
    this.hiringDate = null;
    this.dismissalDate = null;
    this.docType = "0";
    this.docNumber = "";
  }

  mounted(): void {
    this.autoFillingForm();
  }
}
